/**
 * 资料
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getQuestionTree() {
    return request(api.answer.EXTERNALTYPE + '/all', METHOD.GET);
  },
  async saveQuestionTreeDetail(params) {
    return request(api.answer.EXTERNALTYPE, METHOD.POST, params);
  },
  async getQuestionTreeDetail(keyId) {
    return request(api.answer.EXTERNALTYPE + "/" + keyId, METHOD.GET);
  },
  async delQuestionTree(params) {
    return request(api.answer.EXTERNALTYPE + '/delete?infoTypeId=' + params, METHOD.GET);
  },
  async getKeyWords() {
    return request(api.answer.KEYWORDS + '/all', METHOD.GET);
  },
  async saveFormDetail(params) {
    return request(api.answer.EXTERNAL, METHOD.POST, params);
  },
  async getFormDetail(keyId) {
    return request(api.answer.EXTERNAL + "/" + keyId, METHOD.GET);
  },
  //新增列表数据接口
  async getProductList(searchResult,page) {
    return request(api.answer.EXTERNAL + '?limit=7&page=' + page, METHOD.GET,searchResult);
  },
  async deleteFileItem(keyId) { // 删除 对外资料
    return request(api.answer.EXTERNAL + "/" + keyId, METHOD.DELETE);
  },

}

export default {dataApi}
